import React, {Fragment,Component} from 'react';
import axios from 'axios';
import {connect} from 'react-redux';
import {Label,Menu, Message, Form, Table, Tab} from 'semantic-ui-react';
import Panel from '../../components/Panel';
import {Breadcrumb,Divider,Progress, Input, Step, Header,Modal,Dimmer, Loader, Grid, Segment, Item, Image, Popup, Button, Icon, Card} from 'semantic-ui-react';
import QRCode from 'qrcode.react';
import { Link, Redirect } from 'react-router-dom'
import {withTranslation} from 'react-i18next';
import {fetchUserStatus} from '../actions';

const notifications = [{
  title:"2023.11.30",
  items:[
    "Start Surfboard Supporting"
  ]
},{
  title:"2023.11.18",
  items:[
    "Start Ticket Support for Pro Users",
    "Start Profile Resetting"
  ]
},{
  title:"2023.11.08",
  items:[
    "Start Hysteria2 Protocol Supporting",
    "Start Singbox Clients Supporting"
  ]
},{
  title:"2023.10.08",
  items:[
    "Start Apple TV Supporting"
  ]
}]

const notifications2 = [{
  title:"2023.11.30 更新",
  items:[
    "新增 Surfboard 客户端支持"
  ]
},{
  title:"2023.11.08 更新",
  items:[
    "新增 Hysteria2 协议支持",
    "新增 Singbox 客户端支持"
  ]
},{
  title:"2023.10.08 更新",
  items:[
    "新增 Apple TV 客户端支持"
  ]
},{
  title:"2022.11.20 更新",
  items:[
    "新增 Shadowsocks 协议支持"
  ]
},{
  title:"2022.5.10 更新",
  items:[
    "新增 GEO 英国节点"
  ]
},{
  title:"2022.2.7 更新",
  items:[
    "更新 VMESS 为 AEAD + TLS",
    "更新 GEO 节点为 Trojan 协议"
  ]
},{
  title:"2022.1.7 更新",
  items:[
    "更新 Clash 全部配置文件",
    "更新 ClashForWindows 的下载链接版本",
    "更新 ClashX 的下载链接版本",
    "强制启动 VMESS 的 AEAD 协议, 会导致2020年10月前的客户端和配置文件无法连接服务器，需要用户进行更新客户端",
    "更新 ClashForAndroid 的下载链接版本",
    "新增 一个新的游戏节点"
  ]
},{
  title:"2021.12.5 更新",
  items:[
    "新增 Netflix 新加坡原创内容节点"
  ]
},{
  title:"2021.11.23 更新",
  items:[
    "新增 Choc 客户端(clash for ios)支持"
  ]
},{
  title:"2021.8.20 更新",
  items:[
    "升级 VMESS 协议, 全部支持 AEAD 加密协议, 建议更新配置文件"
  ]
},{
  title:"2021.8.8 更新",
  items:[
    "升级 Netch 游戏支持, 提高稳定性"
  ]
},{
  title:"2021.6.18 更新",
  items:[
    "新增 Netch 支持",
    "新增 VLESS 协议支持, 请使用Shadowrocket, V2Ray, Netch 订阅, Clash 暂不支持",
  ]
},{
  title:"2021.3.5 更新",
  items:["新增 Trojan 协议支持, 请更新您的客户端"]
},{
  title:"2020.10.10 更新",
  items:["新增 Loon 支持"]
},{
  title:"2020.10.7 更新",
  items:["新增 Surge Mac 和 iOS 支持"]
},{
  title:"2020.9.27 更新",
  items:["新增 iOS 固定国家/地区IP服务器组"]
},{
  title:"2020.9.25 更新",
  items:["新增 iOS 和 Clash 的经济型节点"]
},{
  title:"2020.9.17 更新",
  items:["新增 Clash 固定国家/地区IP服务器组"]
},{
  title:"2020.8.12 更新",
  items:["新增 V2Ray 客户端 V2RayU/V2RayN 支持"]
},{
  title:"2020.8.8 更新",
  items:["新增 Chrome 插件工具: 收藏和快捷打开 GLaDOS 主页"]
},{
  title:"2020.6.26 更新",
  items:["新增 Nintendo Switch 支持"]
},{
  title:"2020.6.17 更新",
  items:["新增 OpenWRT 路由器 / OpenClash 支持"]
},{
  title:"2020.6.11 更新",
  items:["新增每日签到"]
},{
  title:"2020.6.8 更新",
  items:["更新分账管理","邀请用户分成提升到25%","邀请用户可获得14天延期"]
},{
  title:"2020.5.26 更新",
  items:["新增 Cloudflare 测速","结束 Wireguard 测试"]
},{
  title:"2020.5.4 更新",
  items:["新增统计页面","新增本月流量图表"]
},{
  title:"2020.4.19 更新",
  items:["新增 Wireguard 支持"]
},{
  title:"2020.4.6 更新",
  items:["更新服务状态页面","开放 Team 套餐购买"]
},{
  title:"2020.3.25 更新",
  items:["增加 Netflix 的线路选择: AUTO,US,TW","上线 Padavan 支持","上线 IPv6 支持"]
},{
  title:"2020.3.23 更新",
  items:["优化联通电信和移动用户的 Netflix 速度"]
},{
  title:"2020.2.20 更新",
  items:["增加移动和教育网优化路线"]
},{
  title:"2020.2.19 故障备忘",
  items:["20:00PM 附近发生故障，22:00PM 完全恢复, 故障原因是计费服务器宕机, 导致所有节点无法服务。","措施: 在日本和美国部署2台计费服务器，防止单点故障。"]
}]


class Notification extends Component {

    state = {
      open:false,
      help:false,
      redirect:false,
      seconds:10,
      emailNotice:false,
      emailSend:false,
    }

    constructor() {
        super(...arguments);
        this.props.onLoad()
    }

    componentDidMount() {
      if(!localStorage.getItem("1909")){
        this.show(true);
      }
      window.scrollTo(0, 0);
    }

    show = (dimmer) => {

      this.setState({ disabled:true, dimmer, open: true, seconds: 10 })
      setTimeout(()=>{
        this.setState({disabled:false})
      },9000)

      setInterval(()=>{
        if(this.state.seconds != 0){
          this.setState({seconds: this.state.seconds - 1 })
        }
      },1000)

    }

    close = () => this.setState({ open: false })

    renderNotes(){
      return (
        <>
          <Header as='h2' color="blue">
            <Header.Content>域名问题</Header.Content>
            <Header.Subheader>Domain issue</Header.Subheader>
          </Header>
          <p>因为域名污染问题，我们提供多种方式来管理您的账户。</p>
          <Table stackable>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>方式</Table.HeaderCell>
                <Table.HeaderCell>状态</Table.HeaderCell>
                <Table.HeaderCell textAlign='right'>地址</Table.HeaderCell>
              </Table.Row>
            </Table.Header>

            <Table.Body>
              <Table.Row>
                <Table.Cell>网站</Table.Cell>
                <Table.Cell>国内访问</Table.Cell>
                <Table.Cell textAlign='right'><a href="https://glados.rocks">https://glados.rocks</a></Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Chrome 插件</Table.Cell>
                <Table.Cell>Chrome 商店上架中</Table.Cell>
                <Table.Cell textAlign='right'><a href="https://chrome.google.com/webstore/detail/glados/dhjjibbeddglobeoapgppnlnmijajfbb">前往安装</a></Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Github</Table.Cell>
                <Table.Cell>国内访问</Table.Cell>
                <Table.Cell textAlign='right'><a href="https://github.com/glados-network/GLaDOS">https://github.com/glados-network/GLaDOS</a></Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>源站</Table.Cell>
                <Table.Cell>海外访问</Table.Cell>
                <Table.Cell textAlign='right'><a href="https://glados.network">https://glados.network</a></Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
        </>
      )
    }

    renderNotifications(){
      return (
      <Fragment>

          <Table stackable>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Date</Table.HeaderCell>
                <Table.HeaderCell>Change</Table.HeaderCell>
              </Table.Row>
            </Table.Header>

            <Table.Body>
              {notifications.map(function(note,idx){

                return <Table.Row verticalAlign='top' key={idx}>
                  <Table.Cell>{note.title}</Table.Cell>
                  <Table.Cell>
                    {note.items.map((item, idx)=>{
                      return <p key={idx}>{item}</p>
                    })}
                  </Table.Cell>
                </Table.Row>

              })}
            </Table.Body>
          </Table>



      </Fragment>
    )
  }

    checkInfo(){
      localStorage.setItem("1909","1")
      this.close();
    }

  render() {

        if(this.state.redirect){
          return ( <Redirect to={this.state.redirect} /> )
        }

        return (<Grid.Row>
          <Grid.Column>

          <Header as='h2' color="blue">
            <Header.Content>Changelog</Header.Content>
            <Header.Subheader>Service Updates History</Header.Subheader>
          </Header>

          <Grid.Row>
            <Grid.Column>
              {this.renderNotifications()}
            </Grid.Column>
          </Grid.Row>

        </Grid.Column>
      </Grid.Row>);
    }
}

const mapStateToProps = (state) => {
    const main = state.console.main;
    return {status: main.status};
};

const mapDispatchToProps = (dispatch) => {
    return {
        onLoad: () => {
            dispatch(fetchUserStatus());
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Notification));
